(function () {
  const KOENIG_NAME = 'koenigsmacha';
  const AMOUNT_PER_ITEM = 5; // CHF
  const MAX_KOENIG_QTY = 2;
  const CART_ENDPOINT_REGEX = /\/cart(\.js|\/add\.js|\/change\.js|\/update\.js)?(\?|$)/;

  let lastCart = null;

  function debug(label, ...args) {
    // console.log('[GUARD]', label, ...args);
  }

  function getUpcartShadowRoot() {
    const host = document.querySelector('#upCart');
    if (host && host.shadowRoot) {
      return host.shadowRoot;
    }
    return null;
  }

  function formatChf(amount) {
    // amount is number in CHF
    return amount.toFixed(2);
  }

  function applyKoenigsmachaMinimum(cart) {
    if (!cart) return;

    const items = Array.isArray(cart.items) ? cart.items : [];
    const koenigQty = items.reduce((sum, item) => {
      const name = (item.product_title || item.title || '').toLowerCase();
      if (name.includes(KOENIG_NAME)) {
        return sum + (item.quantity || 0);
      }
      return sum;
    }, 0);

    const minValueChf = koenigQty > 0 ? koenigQty * AMOUNT_PER_ITEM : 0;
    const subtotalChf = (cart.total_price || 0) / 100;

    const root = getUpcartShadowRoot();
    if (!root) {
      debug('No Upcart shadow root yet, will try again later');
      return;
    }

    const checkoutBtn = root.querySelector('.upcart-checkout-button');
    if (!checkoutBtn) {
      debug('No checkout button found in Upcart');
      return;
    }

    const checkoutContainer =
      checkoutBtn.closest('.styles_Footer__checkoutButton__') ||
      checkoutBtn.parentElement;

    if (!checkoutContainer || !checkoutContainer.parentNode) {
      debug('No checkout container found');
      return;
    }

    let messageEl = root.querySelector('#koenigsmacha-minimum-message');
    const hasMinimum = minValueChf > 0;
    const belowMinimum = hasMinimum && subtotalChf < minValueChf;
    const overLimit = koenigQty > MAX_KOENIG_QTY;

    // --- Global guard: hard cap on Koenigsmacha quantity ---
    if (overLimit) {
      if (!messageEl) {
        messageEl = root.createElement
          ? root.createElement('div') // some browsers allow this on shadowRoot
          : document.createElement('div');
        messageEl.id = 'koenigsmacha-minimum-message';
        messageEl.style.color = '#b91c1c'; // red
        messageEl.style.margin = '0 0 8px';
        messageEl.style.fontSize = '13px';
        messageEl.style.fontWeight = '500';
        messageEl.style.lineHeight = '1.4';
        checkoutContainer.parentNode.insertBefore(messageEl, checkoutContainer);
      }

      messageEl.textContent = 'Maximal 2 Koenigsmacha Vapes in einer Bestellung';
      messageEl.style.display = 'block';

      checkoutBtn.dataset.koenigDisabled = 'true';
      checkoutBtn.style.pointerEvents = 'none';
      checkoutBtn.style.opacity = '0.5';

      if (!checkoutBtn.dataset.koenigListenerAttached) {
        checkoutBtn.addEventListener(
          'click',
          function (e) {
            if (checkoutBtn.dataset.koenigDisabled === 'true') {
              e.preventDefault();
              e.stopPropagation();
              debug('Blocked checkout click due to Koenigsmacha limit');
            }
          },
          true
        );
        checkoutBtn.dataset.koenigListenerAttached = 'true';
      }

      debug('Applied Koenigsmacha hard limit', {
        koenigQty,
        maxAllowed: MAX_KOENIG_QTY,
      });

      // If over limit, we don't care about minimum logic, just block checkout.
      return;
    }

    // --- Minimum value logic (only applies if not over the hard limit) ---
    if (belowMinimum) {
      const missingChf = minValueChf - subtotalChf;

      if (!messageEl) {
        messageEl = root.createElement
          ? root.createElement('div')
          : document.createElement('div');
        messageEl.id = 'koenigsmacha-minimum-message';
        messageEl.style.color = '#b91c1c'; // red
        messageEl.style.margin = '0 0 8px';
        messageEl.style.fontSize = '13px';
        messageEl.style.fontWeight = '500';
        messageEl.style.lineHeight = '1.4';
        checkoutContainer.parentNode.insertBefore(messageEl, checkoutContainer);
      }

      messageEl.textContent =
        'Mindestbestellwert für Koenigsmacha: CHF ' +
        formatChf(minValueChf) +
        '. Es fehlen noch CHF ' +
        formatChf(missingChf) +
        ' zum Checkout.';

      messageEl.style.display = 'block';

      checkoutBtn.dataset.koenigDisabled = 'true';
      checkoutBtn.style.pointerEvents = 'none';
      checkoutBtn.style.opacity = '0.5';

      if (!checkoutBtn.dataset.koenigListenerAttached) {
        checkoutBtn.addEventListener(
          'click',
          function (e) {
            if (checkoutBtn.dataset.koenigDisabled === 'true') {
              e.preventDefault();
              e.stopPropagation();
              debug('Blocked checkout click due to minimum');
            }
          },
          true
        );
        checkoutBtn.dataset.koenigListenerAttached = 'true';
      }
    } else {
      if (messageEl) {
        messageEl.style.display = 'none';
      }
      checkoutBtn.dataset.koenigDisabled = 'false';
      checkoutBtn.style.pointerEvents = '';
      checkoutBtn.style.opacity = '';
    }

    debug('Applied minimum', {
      koenigQty,
      minValueChf,
      subtotalChf,
      belowMinimum,
    });
  }

  function handleCartJson(cart, source) {
    lastCart = cart;
    debug('Cart updated from', source, cart);
    applyKoenigsmachaMinimum(cart);
  }

  function parseJsonSafe(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      debug('Failed to parse JSON', e);
      return null;
    }
  }

  // --- Patch fetch ---
  if (!window.__koenigFetchPatched) {
    window.__koenigFetchPatched = true;

    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      const input = args[0];
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const options = args[1] || {};

      const isCartRequest = CART_ENDPOINT_REGEX.test(url);
      if (isCartRequest) {
        debug('fetch cart call', url, options);
      }

      return originalFetch.apply(this, args).then(async (response) => {
        if (!isCartRequest) return response;

        try {
          const clone = response.clone();
          const text = await clone.text();
          const json = parseJsonSafe(text);
          if (json && json.items) {
            handleCartJson(json, 'fetch:' + url);
          }
        } catch (e) {
          debug('Error handling fetch cart response', e);
        }
        return response;
      });
    };
  }

  // --- Patch XHR ---
  if (!window.__koenigXHRPatched) {
    window.__koenigXHRPatched = true;

    const OriginalXHR = XMLHttpRequest;
    function PatchedXHR() {
      const xhr = new OriginalXHR();
      let requestUrl = '';

      const originalOpen = xhr.open;
      xhr.open = function (method, url) {
        requestUrl = url;
        if (CART_ENDPOINT_REGEX.test(url)) {
          debug('XHR cart open', method, url);
        }
        return originalOpen.apply(xhr, arguments);
      };

      xhr.addEventListener('readystatechange', function () {
        try {
          if (xhr.readyState !== 4) return;
          if (!CART_ENDPOINT_REGEX.test(requestUrl)) return;

          const text = xhr.responseText;
          const json = parseJsonSafe(text);
          if (json && json.items) {
            handleCartJson(json, 'xhr:' + requestUrl);
          }
        } catch (e) {
          debug('Error handling XHR cart response', e);
        }
      });

      return xhr;
    }

    window.XMLHttpRequest = PatchedXHR;
  }

  // --- Initial cart load ---
  function loadInitialCart() {
    debug('Loading initial cart via /cart.js');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => res.text())
      .then((text) => {
        const json = parseJsonSafe(text);
        if (json && json.items) {
          handleCartJson(json, 'initial');
        }
      })
      .catch((err) => debug('Initial cart load error', err));
  }

  loadInitialCart();

  // --- Watch for Upcart host appearing / re-rendering ---
  const domObserver = new MutationObserver(() => {
    if (lastCart) {
      applyKoenigsmachaMinimum(lastCart);
    }
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

})();
